module.exports = __webpack_public_path__ + "static/media/internet-of-things05.ff5974bc.jpg";